import { configureStore } from '@reduxjs/toolkit';
import agentsReducer from './agentsSlice';
import conversationsReducer from './conversationsSlice';
import notificationsReducer from './notificationsSlice';
import userReducer from './userSlice';

export const store = configureStore({
  reducer: {
    agents: agentsReducer,
    conversations: conversationsReducer,
    notifications: notificationsReducer,
    user: userReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
